import { WorkItemInfo } from 'runtime/data/workiteminfo';

export class RuntimeHostClosed {
    constructor(public workItemInfo?: WorkItemInfo, public suppressTeardown = false) { }

    static eventName() { return 'RuntimeHostClosed'; }

    eventName = RuntimeHostClosed.eventName;
}